import {getContext} from "./api/ApiApp";
import {useDispatch} from "react-redux";
import {rxInit} from "./slices/appSlice";
import {dbClear, dbGet, dbGetAll, dbOpen} from "./util/db-util";
import useI18n from "./util/useI18n";
import {useCallback} from "react";
import {jwtDecode} from "jwt-decode";

const useAppInit = () => {
  const dispatch = useDispatch();

  const {handleI18n, changeLanguage} = useI18n();

  const handleTransactions = (db, transactionsFull, context) => {
    const txTransactions = db.transaction("transactions", "readwrite");
    const storeTransactions = txTransactions.objectStore("transactions");

    return (transactionsFull ? dbClear(storeTransactions) : Promise.resolve())
      .then(() => {
        (context.transactions || []).forEach(t => storeTransactions.put(t));
        (context.transactionsDeleted || []).forEach(t => storeTransactions.delete(t));
      })
      .then(() => dbGetAll(storeTransactions))
      .then(r => context.transactions = r);
  };

  const init = useCallback(user => {
    return dbOpen()
      .then(db => {
        const txConfig = db.transaction("config", "readwrite");
        const storeConfig = txConfig.objectStore("config");

        let transactionsFull = true;

        return Promise.all([dbGet(storeConfig, "i18nv"), dbGet(storeConfig, "transactionsFrom")])
          .then(([i18nv, transactionsFrom]) => {
            const params = {i18nv: null};

            if (process.env.NODE_ENV === "production" && i18nv) {
              params.i18nv = i18nv;
            }

            if (transactionsFrom) {
              params.transactionsFrom = transactionsFrom;

              transactionsFull = false;
            }

            return getContext(params);
          })
          .then(context => {
            return handleI18n(db, context.i18n, context.locale)
              .then(() => changeLanguage(context.locale))
              .then(() => handleTransactions(db, transactionsFull, context))
              .then(() => {
                if (user) {
                  context.token = jwtDecode(user.accessToken);
                }

                dispatch(rxInit(context));

                const txConfig = db.transaction("config", "readwrite");
                const storeConfig = txConfig.objectStore("config");

                storeConfig.put(context.serverTime, "transactionsFrom");

                return context;
              });
          });
      });
  }, [changeLanguage, dispatch, handleI18n]);

  return {init};
};

export default useAppInit;
